import BaseModelAPI from '../BaseModelAPI';

export default class RepairList extends BaseModelAPI {

	static entity = 'repairlist'
	static entityName = 'repair';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
